<template>
	<div class="flex items-center gap-2 justify-center mt-4">
		<!-- Previous Button -->
		<button
			class="w-10 h-10 flex items-center justify-center rounded-full bg-gray-200 text-gray-700 hover:bg-gray-300 disabled:opacity-50"
			:disabled="currentPage === 1"
			@click="goToPage(currentPage - 1)"
		>
			‹
		</button>

		<!-- Page Numbers -->
		<button
			v-for="(page, i) in selectPages"
			:key="i"
			class="w-10 h-10 flex items-center justify-center rounded-full transition-colors"
			:class="[
				currentPage === page
					? 'bg-blue-600 text-white shadow-md'
					: 'bg-gray-200 text-gray-700 hover:bg-gray-300',
			]"
			@click="goToPage(page)"
		>
			{{ page }}
		</button>

		<!-- Next Button -->
		<button
			class="w-10 h-10 flex items-center justify-center rounded-full bg-gray-200 text-gray-700 hover:bg-gray-300 disabled:opacity-50"
			:disabled="currentPage === totalPages"
			@click="goToPage(currentPage + 1)"
		>
			›
		</button>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	computed: {
		...mapGetters('pagination', [
			'selectPages',
			'currentPage',
			'totalPages',
		]),
	},
	methods: {
		goToPage(page) {
			if (page > 0 && page <= this.totalPages) {
				this.$store.dispatch('pagination/setCurrentPage', page);
				this.$emit('page-change', page);
			}
		},
	},
};
</script>
